// extracted by mini-css-extract-plugin
export default {"container":"storage-create-warehouse_container__U89B5","button":"storage-create-warehouse_button__UowED","link":"storage-create-warehouse_link__D4bNC"};